import contracts from "./contracts";
import { FarmConfig, FarmV2Config, QuoteToken } from "./types";

const YUNA_GOERLI = "0xf889850CB53b9f63Bd3382a03e1a63D97F4Ff999";
const LP_GOERLI = "0x58460ab9170e48b0c4ccc83dffdfd033eb3f3ad5";


const YUNA_MAIN = "0x2F6f397332B0F8b4536430bCC97980aA838f62f9";
const LP_MAIN = "0x99b975590364dfdEa0ED8550d0d862c78E07C43d";

const farms: FarmConfig[] = [
];

export const farmsV2Config: FarmV2Config[] = [
  {
    farmAddress: {
      5: "0x3485b22e0B9e4c97b453CA97744b6dd9e353aE70",
      1: "0xD6368280d32cB4d3f740B114aB254263d01CC653",
    },
    lpSymbol: "YUNA-ETH LP 28 DAY",
    lpAddresses: {
      // Token being staked
      5: YUNA_GOERLI,
      1: LP_MAIN,
    },
    tokenSymbol: "YUNA-ETH",
    tokenAddresses: {
      // Reward Token
      5: YUNA_GOERLI,
      1: YUNA_MAIN,
    },
    quoteTokenSymbol: QuoteToken.ETH,
    quoteTokenAdresses: contracts.wbnb,
    earlyWithdrawalSeconds: 2419200,
  },
  {
    farmAddress: {
      4: "0x16AEabFC6A1C3Cc44829A1Fbc44D9b68f85d082a",
      1: "0x7b4F8e93186C8AA795DA36E8C4D4bFFda38E63A4",
    },
    lpSymbol: "YUNA 28 DAY",
    lpAddresses: {
      // Token being staked
      4: LP_GOERLI,
      1: YUNA_MAIN,
    },
    tokenSymbol: "YUNA",
    tokenAddresses: {
      // Reward Token
      4: YUNA_GOERLI,
      1: YUNA_MAIN,
    },
    quoteTokenSymbol: QuoteToken.CAKE,
    quoteTokenAdresses: contracts.wbnb,
    earlyWithdrawalSeconds: 2419200,
  },
];

export default farms;
